// extracted by mini-css-extract-plugin
module.exports = {"tabs":"Tabs_tabs__tVXxO","tab":"Tabs_tab__HeYbT","active":"Tabs_active__xSwfW","panel":"Tabs_panel__uEe2n"};